import React from 'react'
import './Footer.css'

function Footer() {
    return (
        <div className="footer">
            <footer>
            <p> Airbnb clone! No rights reserved - this is a demo!</p>
            <p>Privacy - Terms - Sitemap - Company Details</p>
            </footer>
        </div>
    )
}

export default Footer
